"use strict";
// This file comes from @peachjar/api-school-management/dist/api/GradeLevels.
// We don't include the package because our inter-package dep situation is
// a mess and the Serverless framework that deploys our
// lambda-flyer-email-job-producer repo is not a fan of postinstall scripts
// that we use to manage peer dependencies.
//
// Some day we will fix our packages and when that day comes, we can replace
// this file with a reference.
Object.defineProperty(exports, "__esModule", { value: true });
exports.withinGradeLevels = exports.createGradeRange = exports.toOrdinal = exports.GradeLevelsList = exports.gradeLevels = exports.GradeLevels = void 0;
var GradeLevels;
(function (GradeLevels) {
    GradeLevels["EarlyChildhoodEducation"] = "ECE";
    GradeLevels["Prekindergarten"] = "PK";
    GradeLevels["Kindergarten"] = "KG";
    GradeLevels["Grade1"] = "1";
    GradeLevels["Grade2"] = "2";
    GradeLevels["Grade3"] = "3";
    GradeLevels["Grade4"] = "4";
    GradeLevels["Grade5"] = "5";
    GradeLevels["Grade6"] = "6";
    GradeLevels["Grade7"] = "7";
    GradeLevels["Grade8"] = "8";
    GradeLevels["Grade9"] = "9";
    GradeLevels["Grade10"] = "10";
    GradeLevels["Grade11"] = "11";
    GradeLevels["Grade12"] = "12";
    GradeLevels["ContinuingEducation"] = "CE";
    GradeLevels["NotGraded"] = "N";
    GradeLevels["Unknown"] = "unknown";
})(GradeLevels = exports.GradeLevels || (exports.GradeLevels = {}));
exports.gradeLevels = {
    EarlyChildhoodEducation: 'ECE',
    Prekindergarten: 'PK',
    Kindergarten: 'KG',
    Grade1: '1',
    Grade2: '2',
    Grade3: '3',
    Grade4: '4',
    Grade5: '5',
    Grade6: '6',
    Grade7: '7',
    Grade8: '8',
    Grade9: '9',
    Grade10: '10',
    Grade11: '11',
    Grade12: '12',
    ContinuingEducation: 'CE',
    NotGraded: 'N',
    Unknown: 'unknown',
};
exports.GradeLevelsList = Object.values(GradeLevels);
function toOrdinal(level) {
    switch (level) {
        case GradeLevels.EarlyChildhoodEducation: return 0;
        case GradeLevels.Prekindergarten: return 1;
        case GradeLevels.Kindergarten: return 2;
        case GradeLevels.Grade1: return 3;
        case GradeLevels.Grade2: return 4;
        case GradeLevels.Grade3: return 5;
        case GradeLevels.Grade4: return 6;
        case GradeLevels.Grade5: return 7;
        case GradeLevels.Grade6: return 8;
        case GradeLevels.Grade7: return 9;
        case GradeLevels.Grade8: return 10;
        case GradeLevels.Grade9: return 11;
        case GradeLevels.Grade10: return 12;
        case GradeLevels.Grade11: return 13;
        case GradeLevels.Grade12: return 14;
        case GradeLevels.ContinuingEducation: return 15;
        default: return 16;
    }
}
exports.toOrdinal = toOrdinal;
function createGradeRange(lowGradeInclusive, highGradeInclusive) {
    var low = toOrdinal(lowGradeInclusive);
    var high = toOrdinal(highGradeInclusive);
    if (low > high) {
        var swap = high;
        high = low;
        low = swap;
    }
    return exports.GradeLevelsList.slice(low, high + 1);
}
exports.createGradeRange = createGradeRange;
function withinGradeLevels(target, lowBound, highBound) {
    var targetOrdinal = toOrdinal(target);
    return toOrdinal(lowBound) <= targetOrdinal && targetOrdinal <= toOrdinal(highBound);
}
exports.withinGradeLevels = withinGradeLevels;
//# sourceMappingURL=GradeLevels.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/flyer-email-builder/dist/api/GradeLevels.js
// module id = 3136
// module chunks = 0